import { observable, action, runInAction } from "mobx";
import { Dashboard, Configuracao, Usuario } from "../../../services";
import { error } from "../../../utils/MensagemUtil";
import { sessaoStore } from "../../../stores";
import * as CsAvatar from "../../../constantes/CsAvatars";
import * as CsSituacaoOrcamento from "../../../constantes/CsSituacaoOrcamento";
import { moeda } from "../../../utils/MascaraUtil";
import CsMeses from "../../../constantes/CsMeses";

class DashboardStore {
  @observable
  totais = {};

  @observable
  empresa = {};

  @observable
  usuario = { avatar: {} };

  @observable
  grafico_orcamentos_valor_situacoes = [];

  @observable
  grafico_orcamentos_total_situacoes = [];

  @observable
  grafico_orcamentos_mensais = [];

  @observable
  cores = [
    "#428bca",
    "#A0C7F2",
    "#6610f2",
    "#b4a1dd",
    "#e299b7",
    "#d71f4b",
    "#ee682f",
    "#f0ad4e",
    "#5cb85c",
    "#2eb398",
    "#68a0a5",
    "#5bc0de",
    "#b4b7b9"
  ];

  @observable
  fetching = false;

  @action.bound
  async buscarTotaisDashboard() {
    try {
      this.fetching = true;

      const result = await Dashboard.obterEstatisticasTotais();
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.totais = result;
    } finally {
      runInAction(() => {
        this.fetching = false;
      });
    }
  }

  @action.bound
  async obterUsuarioLogado() {
    try {
      this.fetching = true;

      const result = await Usuario.obterLogado(sessaoStore.usuario.login);
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.usuario = {
        ...result,
        avatar: CsAvatar.valueOf(result.avatar)
      };
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async obterEmpresa() {
    try {
      this.fetching = true;

      const result = await Configuracao.obterEmpresaUsuarioLogado();
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.empresa = result;
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async obterEstatisticasTotaisOrcamentosSituacao() {
    try {
      this.fetching = true;

      const result = await Dashboard.obterEstatisticasTotaisOrcamentosSituacao();
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.grafico_orcamentos_valor_situacoes = [["Key", "Situação"]].concat(
        result.map(row => [CsSituacaoOrcamento.valueOf(row.situacao).descricao, parseFloat(row.valor, 0.0)])
      );

      this.grafico_orcamentos_total_situacoes = [["Key", "Situação"]].concat(
        result.map(row => [CsSituacaoOrcamento.valueOf(row.situacao).descricao, parseInt(row.total, 0.0)])
      );
    } finally {
      runInAction(() => {
        this.fetching = false;
      });
    }
  }

  @action.bound
  async obterEstatisticasTotaisOrcamentosMensal() {
    try {
      this.fetching = true;

      const result = await Dashboard.obterEstatisticasTotaisOrcamentosMensal();
      // console.log(result);
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.grafico_orcamentos_mensais = [["Mês", "Valor (R$)"]].concat(
        result.map(row => [CsMeses.valueOf(row.mes).sigla, { v: row.valor, f: moeda(row.valor) }])
      );
    } finally {
      runInAction(() => {
        this.fetching = false;
      });
    }
  }
}

export default new DashboardStore();



// WEBPACK FOOTER //
// ./src/views/dashboard/stores/DashboardStore.js